import type { ApiSimulationParameterValue } from '@nexelem/graphne-api';
import { createModal, StaticModal } from '@nexelem/modals';
import { GanttSimulationCreateForm } from '../../SimulationParameters';
import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../../hooks';
import { useFormContext } from 'react-hook-form';

type OptimizeParametersModalProps = {
  onSubmit: (data: ApiSimulationParameterValue[]) => Promise<void>;
};

const OptimizePlanParametersModal = ({ onSubmit }: OptimizeParametersModalProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <StaticModal fullScreen onClose={closeOptimizePlanParametersModal}>
      <GanttSimulationCreateForm
        cancelButton={<CancelButton />}
        headerTitle={tWrapper('optimizePlan')}
        submitButtonLabel={tWrapper('optimizePlan')}
        onSubmit={onSubmit}
      />
    </StaticModal>
  );
};

const CancelButton = () => {
  const { tWrapper } = useCustomTranslation('common');

  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Button disabled={isSubmitting} variant="outlined" onClick={closeOptimizePlanParametersModal}>
      {tWrapper('cancel')}
    </Button>
  );
};

export const { openOptimizePlanParametersModal, closeOptimizePlanParametersModal } = createModal(
  OptimizePlanParametersModal,
  {
    name: 'OptimizePlanParametersModal',
  },
);
